import { io } from 'socket.io-client';

class SocketService {
    socket = null;
    listeners = new Map();
    
    connect() {
        if (this.socket?.connected) {
            return this.socket;
        }
        
        // Подключаемся к API серверу
        const apiUrl = 'http://146.103.99.92:3000';
        this.socket = io(apiUrl, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
        });
        
        this.socket.on('connect', () => {
            console.log('WebSocket connected:', this.socket.id);
        });
        
        this.socket.on('disconnect', (reason) => {
            console.log('WebSocket disconnected:', reason);
        });
        
        this.socket.on('error', (error) => {
            console.error('WebSocket error:', error);
        });
        
        // Универсальный обработчик для логирования всех событий
        this.socket.onAny((eventName, ...args) => {
            console.log(`[SocketService] Event received: ${eventName}`, args);
        });
        
        return this.socket;
    }
    
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
    
    emit(event, data) {
        if (!this.socket?.connected) {
            console.warn('Socket not connected, cannot emit:', event);
            return;
        }
        this.socket.emit(event, data);
    }
    
    on(event, callback) {
        if (!this.socket) {
            console.warn('Socket not initialized');
            return;
        }
        
        // Сохраняем слушателей для управления
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(callback);
        
        this.socket.on(event, callback);
    }
    
    off(event, callback) {
        if (!this.socket) return;
        
        if (callback) {
            this.socket.off(event, callback);
            this.listeners.get(event)?.delete(callback);
        } else {
            this.socket.off(event);
            this.listeners.delete(event);
        }
    }
    
    once(event, callback) {
        if (!this.socket) {
            console.warn('Socket not initialized');
            return;
        }
        this.socket.once(event, callback);
    }
}

const socketService = new SocketService();
export default socketService;